export interface Taxa {
  noPrazo: number
  total: number
  /** `null` = sem denominador na janela. NÃO é zero: ver `TaxaCard`. */
  taxa: number | null
}

export type SituacaoMembro =
  | 'ativo'
  | 'nao_renovacao'
  | 'inativo'
  | 'churn'
  | 'pausado'
  | 'cancelado'
  | 'outro'

export interface ComposicaoBase {
  situacao: SituacaoMembro
  total: number
}

export interface Renovacao {
  previstas: number
  renovadas: number
  taxa: number | null
}

export interface ChurnMensal {
  saidas: number
  baseInicial: number
  taxa: number | null
}

export interface Nps {
  media: number | null
  respostas: number
  base: number
}

export interface SaudeBase {
  configurado: boolean
  baseAtiva: number
  composicao: ComposicaoBase[]
  entradasNoPeriodo: number
  renovacao: Renovacao
  emChurnHoje: number
  churn: ChurnMensal
  churnMensalDisponivel: boolean
  nps: Nps
  npsDisponivel: boolean
}

export interface SlaSetor {
  setor: string
  noPrazo: number
  total: number
  /** Nunca `null`: um setor só aparece se tem ao menos uma tarefa medível. */
  taxa: number
}

export interface Operacao {
  configurado: boolean
  sla: Taxa
  eficacia: Taxa
  slaPorSetor: SlaSetor[]
  coberturaTipo: Taxa
  tarefas: number
}

export interface RelatorioTatico {
  id: string
  nome: string
  setor: string | null
  noPrazo: boolean
  entregue: boolean
}

export interface Cadencia {
  configurado: boolean
  relatoriosTaticos: Taxa
  detalhe: RelatorioTatico[]
}

export const ROTULO_SITUACAO: Record<SituacaoMembro, string> = {
  ativo: 'Ativos',
  nao_renovacao: 'Não renovação',
  inativo: 'Inativos',
  churn: 'Churn',
  pausado: 'Pausados',
  cancelado: 'Cancelados',
  outro: 'Outros',
}
